 <template>
  <b-sidebar v-touch:swipe.stop id="pageUser" shadow :lazy="true" :right="false" :backdrop="true" width="320px" v-if="pageUser" :no-header="true" v-model="pageUserShow" class="sidebarPageUser">

    <h3 class="text-center font-weight-bold">
      기기 소유자 정보
    </h3>

    <b-media class="m-2 pageMedia">
      <template #aside>

        <router-link v-if="pageUser.photoURL" :to="{ name: 'tinkUser', params: { uid: pageUser.id, mode: 'list' } }" custom v-slot="{ navigate }">
          <b-avatar @click="navigate" @keypress.enter="navigate" role="link" button square round="sm" :src="pageUser.photoURL" class="mr-0 mt-2 ml-1 cursor-pointer" style="width: 4.1rem; height: 4.1rem;" v-b-tooltip :title="`${pageUser.displayName}의 기기 목록 보기`"/>
        </router-link>

        <router-link v-else :to="{ name: 'tinkUser', params: { uid: pageUser.id, mode: 'list' } }" custom v-slot="{ navigate }">
          <b-avatar @click="navigate" @keypress.enter="navigate" role="link" button square round="sm" class="mr-0 mt-2 ml-1 cursor-pointer" style="width: 4.1rem; height: 4.1rem;" v-b-tooltip :title="`${pageUser.displayName}의 기기 목록 보기`"/>
        </router-link>

      </template>
      <b-list-group>
        <b-list-group-item variant="secondary" class="font-weight-bold" style="padding: 0.1rem 0.1rem 0.1rem 0.5rem">
          <big>
            <router-link :to="{ name: 'tinkUser', params: { uid: pageUser.id, mode: 'list' } }" v-b-tooltip :title="`${pageUser.displayName}의 기기 목록 보기`" custom v-slot="{ navigate }">
              <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                {{pageUser.displayName}}
              </span>  
            </router-link>
          </big>
        </b-list-group-item>
        <b-list-group-item class="p-1 cursor-pointer fontSizeDot8" v-b-tooltip title="누르면 복사됩니다." @click="copyToClipboard">
          {{pageUser.id}}
        </b-list-group-item>
        <b-list-group-item class="p-1 fontSizeDot9">
          <span v-if="pageUser.openEmail && pageUser.emailVerified">
            <a :href="`mailto:${pageUser.email}`">{{pageUser.email}}</a>
          </span>
          <span v-else>
            전자우편 공개안함
          </span>
        </b-list-group-item>
        <b-list-group-item v-if="isLoginUserPageUser || isIdLoginUserFriend(pageUser.id)" class="p-1 font-weight-bold text-primary fontSizeDot9">
          <span v-if="isLoginUserPageUser">
            나
          </span>
          <span v-else-if="isIdLoginUserFriend(pageUser.id) && this.isIdPageUserFriend(this.loginUser.id)">
            서로 친구
          </span>
          <span v-else-if="isIdLoginUserFriend(pageUser.id) && !this.isIdPageUserFriend(this.loginUser.id)">
            나의 친구
          </span>
          <span v-else-if="!isIdLoginUserFriend(pageUser.id) && this.isIdPageUserFriend(this.loginUser.id)">
            나는 친구
          </span>
          <span v-else>
            친구 아님
          </span>
        </b-list-group-item>

      </b-list-group>
    </b-media>

    <div v-if="pageUser.description !=''" class="m-2 border gothic p-1 pl-2 pr-2" style="white-space: pre;">{{ pageUser.description.trim("\n").trim("\r") }}</div>

    <div class="accordion" role="tablist">

      <div v-if="isLoginUserPageUserReadable && pageUser.devices.length != 0" >
        <div class="p-0 mr-2 ml-2 border">
          <h4 role="tab" v-b-toggle.pageUserDeviceList variant="light" class="m-0 pt-2 pl-2 pr-2 pb-2 font-weight-bold cursor-pointer fontSize1Dot1">
            기기 목록

          </h4>
        </div>

        <b-collapse id="pageUserDeviceList" accordion="menuAccordion" role="tabpanel" class="m-0 p-0 fontSizeDot9" v-if="pageDevice == null && pageSensor == null">
          <b-list-group v-if="pageUser.devices != null" squared class="text-left mt-0 mr-2 ml-2 mb-0 border-top-0 rounded-0">
            <b-list-group-item class="m-0 p-1 pl-2 mb-0 border-top-0" v-for="(device, index) in pageUser.devices" :key="`pageUser_${index}`">
              <b-badge variant="success" class="float-left mt-1 mr-1">d</b-badge>
              <router-link :to="{ name: 'tinkDevice', params: { did: device.id } }" custom v-slot="{ navigate }">
                <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                  {{ device.name }}
                </span>  
              </router-link>
            </b-list-group-item>
          </b-list-group>
        </b-collapse>

        <b-collapse id="pageUserDeviceList" accordion="menuAccordion" role="tabpanel" class="m-0 p-0 fontSizeDot9" v-else>
          <b-list-group v-if="pageUser.devices && pageUser.foldersInfo" squared class="text-left mt-0 mr-2 ml-2 mb-0 border-top-0 rounded-0">
            <b-list-group-item class="m-0 p-1 pl-2 mb-0 border-top-0" v-for="(device, index) in pageUser.devices" :key="`pageUser_${index}`">
              <b-badge variant="success" class="float-left mt-1 mr-1">d</b-badge>
              <router-link v-if="pageUser.foldersInfo[index] && pageUser.foldersInfo[index].name" :to="{ name: 'tinkDevice', params: { did: device } }" custom v-slot="{ navigate }">
                <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                  {{ pageUser.foldersInfo[index].name }}
                </span>  
              </router-link>
              <router-link v-else :to="{ name: 'tinkDevice', params: { did: device } }" custom v-slot="{ navigate }">
                <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                  {{ index }}
                </span>  
              </router-link>
            </b-list-group-item>
          </b-list-group>
        </b-collapse>
      </div>


      <div v-if="pageUser.openFriends">
        <div class="p-0 mr-2 ml-2 border">
          <h4 role="tab" v-b-toggle.pageUserFriendList variant="light" class="m-0 pt-2 pl-2 pr-2 pb-2 font-weight-bold cursor-pointer fontSize1Dot1">
            친구 목록
          </h4>
        </div>
        <b-collapse id="pageUserFriendList" accordion="menuAccordion" role="tabpanel" class="m-0 p-0 fontSizeDot9">
          <b-list-group squared class="text-left mt-0 mr-2 ml-2 mb-0 border-top-0 rounded-0">

            <b-list-group-item class="m-0 p-1 pl-2 mb-0 border-top-0" v-for="friend in pageUser.frApp" :key="`pageUserFriend_${friend}`">

              <b-badge variant="warning" class="float-left mt-1 mr-1">u</b-badge>
              <router-link v-if="typeof(pageUser.frAppCache[friend]) != 'undefined' && typeof(pageUser.frAppCache[friend].displayName) != 'undefined'" :to="{ name: 'tinkUser', params: { uid: friend } }" v-b-tooltip :title="friend" custom v-slot="{ navigate }">
                <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                  {{ pageUser.frAppCache[friend].displayName }}
                </span>  
              </router-link>

              <router-link v-else :to="{ name: 'tinkUser', params: { uid: friend } }" custom v-slot="{ navigate }">
                <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                  {{ friend }}
                </span>  
              </router-link>

            </b-list-group-item>

          </b-list-group>
        </b-collapse>
      </div>

      <div v-if="pageUser.openBookmark">
        <div class="p-0 mr-2 ml-2 border">
          <h4 role="tab" v-b-toggle.pageUserBookmarkList variant="light" class="m-0 pt-2 pl-2 pr-2 pb-2 font-weight-bold cursor-pointer fontSize1Dot1">
            북마크 목록
          </h4>
        </div>

        <b-collapse id="pageUserBookmarkList" accordion="menuAccordion" role="tabpanel" class="m-0 p-0 fontSizeDot9">

          <b-list-group squared class="text-left mt-0 mr-2 ml-2 mb-0 border-top-0 rounded-0">

            <b-list-group-item class="m-0 p-1 pl-2" v-for="(bookmarkList, listIndex) in pageUser.bookmarks" :key="`bookmarkList_${listIndex}`">

              <div role="tab" variant="light" class="m-1 p-0 font-weight-bold cursor-pointer" @click="$root.$emit('bv::toggle::collapse', 'bookmarkList_' + listIndex)">
                  {{bookmarkList.name}}
              </div>

              <b-collapse :id="`bookmarkList_${listIndex}`" :visible="listIndex==0" accordion="bookmarkAccordion" role="tabpanel" class="m-0 p-0">
                <b-list-group squared class="mt-0 mr-1 ml-1 mb-0">

                  <b-list-group-item class="m-0 p-1" v-for="(bookmark, index) in bookmarkList.list" :key="`bookmark_${listIndex}_${index}`">

                    <b-badge v-if="bookmark.type == 10" variant="warning" class="float-left mt-1 mr-1" style="width: 17px; height: 17 px; padding:1px;">u</b-badge>
                    <b-badge v-if="bookmark.type == 20" variant="success" class="float-left mt-1 mr-1" style="width: 17px; height: 17px; padding:1px;">d</b-badge>
                    <b-badge v-if="bookmark.type == 30" variant="info" class="float-left mt-1 mr-1" style="width: 17px; height: 17px; padding:1px;">s</b-badge>

                    <router-link v-if="bookmark.uid && bookmark.uName" :to="{ name: 'tinkUser', params: { uid: bookmark.uid.trim() } }" custom v-slot="{ navigate }">
                      <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                        {{bookmark.uName}}
                      </span>  
                    </router-link><span v-if="bookmark.uid && bookmark.uName">{{$t("common.apostropheS")}} </span>

                    <router-link v-if="bookmark.did && bookmark.dName" :to="{ name: 'tinkDevice', params: { did: bookmark.did.trim() } }" custom v-slot="{ navigate }">
                      <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                        {{bookmark.dName}}
                      </span>  
                    </router-link><span v-if="bookmark.did && bookmark.dName">{{$t("common.apostropheS")}} </span>

                    <router-link v-if="bookmark.type == 10 && bookmark.id && bookmark.name" :to="{ name: 'tinkUser', params: { uid: bookmark.id.trim() } }" custom v-slot="{ navigate }">
                      <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                        {{bookmark.name}}
                      </span>  
                    </router-link>

                    <router-link v-if="bookmark.type == 20 && bookmark.id && bookmark.name" :to="{ name: 'tinkDevice', params: { did: bookmark.id.trim() } }" custom v-slot="{ navigate }">
                      <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                        {{bookmark.name}}
                      </span>  
                    </router-link>

                    <router-link v-if="bookmark.type == 30 && bookmark.id && bookmark.name" :to="{ name: 'tinkSensor', params: { sid: bookmark.id.trim() } }" custom v-slot="{ navigate }">
                      <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                        {{bookmark.name}}
                      </span>  
                    </router-link>

                  </b-list-group-item>
                </b-list-group>
              </b-collapse>

            </b-list-group-item>
          </b-list-group>
        </b-collapse>
      </div>
    </div>

    <tinkList v-touch:swipe.stop v-if="sensorListForTicker.length != 0" :controls="false" :start="0" :show="2" rowClass="headerTickerRow" class="headerTickerBox bg-blue-lighter" :autoRotate="0" :swipeRightDisabled="true">
      <tinkListItem class="headerTickerSensorBox" v-for="(sensor,index) in sensorListForTicker" :key="`sensor_${index}`">

        <div v-if="pageDevice == null" class="gothic text-center headerTickerDeviceName border border-bottom-0 border-blue-dark">
          <router-link :to="{ name: 'tinkDevice', params: { did: pageUserDeviceList[sensor.device].id} }" custom v-slot="{ navigate }">
            <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
              {{pageUserDeviceList[sensor.device].name}}
            </span>
          </router-link>
        </div>
        <div v-else class="gothic text-center headerTickerDeviceName border border-bottom-0 border-blue-dark">
          <router-link :to="{ name: 'tinkDevice', params: { did: pageDevice.id} }" custom v-slot="{ navigate }">
            <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
              {{pageDevice.name}}
            </span>
          </router-link>
        </div>


        <div class="gothic text-center headerTickerSensorName border border-bottom-0 border-blue-dark bg-blue-light">
          <router-link :to="{ name: 'tinkSensor', params: { sid: sensor.id} }" custom v-slot="{ navigate }">
            <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
              {{sensor.name}}
            </span>
          </router-link>
        </div>

        <div class="p-1 gothic headerTickerValueBox border border-blue-dark bg-white" v-b-tooltip.hover.top :title="(sensor.lastValues)? dateToString(sensor.lastValues.t.toDate()): ''">
          <div v-for="(sensorValue, valueIndex) in sensor.values" :key="`sensor_${index}_${valueIndex}`">
            <div v-if="!sensorValue.hold" class="d-flex flex-nowrap justify-content-between headerTickerValue">
              <div class="headerTickerValueName">{{sensorValue.name}}</div>
              <div class="headerTickerValueValue">{{sensor.lastValues.v[valueIndex]}}</div>
              <div class="headerTickerValueUnit" v-if="sensorValue.unit">{{sensorValue.unit}}</div>
            </div>
          </div>
        </div>
      </tinkListItem>
  </tinkList>


  </b-sidebar>
</template>
<script>

  import uiUtil from "@/mixins/util.js"
  import user from "@/mixins/user.js"
  import eventBus from "@/plugins/eventBus.js";

  import {tinkList, tinkListItem} from "@/components/common/tinkList.vue"

  export default {
    name: "tPageUser",
    mixins: [uiUtil, user],
    props: {
      pageUser: {
        type: Object,
        default: null
      },
      pageDevice: {
        type: Object,
        default: null
      },
      pageSensor: {
        type: Object,
        default: null
      },
    },
    components: {
      tinkList, tinkListItem,
    },
    data: function() {
      return {
        pageUserShow: false,
      }
    },
    methods: {
    },
    computed: {
      sensorListForTicker: function() {
        if(this.pageDevice != null) {
          let result = [];
          for(let sensorName in this.pageDevice.sensors) {
            if(this.pageDevice.sensors[sensorName].lastValues != null) {
              result.push(this.pageDevice.sensors[sensorName]);
            }
          }
          return result;
        }
        else {
          return this.pageUserSensorArrayHasData;
        }
      }
    },
    mounted: function() {
      eventBus.$on('busShowPageUser', (flag) => {
        this.pageUserShow = flag;
      });
    },
  }
</script>
